import { render, staticRenderFns } from "./DocumentPersonalInfo.vue?vue&type=template&id=4048835c"
import script from "./DocumentPersonalInfo.vue?vue&type=script&lang=ts"
export * from "./DocumentPersonalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports